import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { FloppyDisk } from '@phosphor-icons/react'
import cookie from 'react-cookies'

import { BonusPromoContext } from '../context/BonusPromoContext'
import { BasePromoContext } from '../context/BasePromoContext'
import { ScalePromoContext } from '../context/ScalePromoContext'
import Select from 'react-select'
import { PROMO_CLIENT_TYPE, PROMO_QUALIFIER_TYPE } from '../../constants/constant'
import AsyncSelect from 'react-select/async'
import { AssortedPromoContext } from '../context/AssortedPromoContext'
import { AssortedBonusPromoContext } from '../context/AssortedBonusPromoContext'
import { AssortedScalePromoContext } from '../context/AssortedScalePromoContext'
import axios from 'axios'

import ProductSection from '../components/sections/ProductSection'
import BonusPromoRuleSection from '../components/sections/BonusPromoRuleSection'
import DiscountPromoRuleSection from '../components/sections/DiscountPromoRuleSection'
import DateAndDescriptionSection from '../components/sections/DateAndDescriptionSection'
import StickyActionBar from '../../components/StickyActionBar'
import {
  PROMO_QUALIFIER_FIELDS,
  PROMO_EMPTY_QUALIFIERS,
  PROMO_EMPTY_SELECTED_QUALIFIERS,
  buildAppliesToFromSelectedQualifiers,
  hasAnySelectedQualifier
} from '../constants/promoQualifiers'

const EMPTY_QUALIFIERS = PROMO_EMPTY_QUALIFIERS
const EMPTY_SELECTED_QUALIFIERS = PROMO_EMPTY_SELECTED_QUALIFIERS

const CreatePromo = () => {
  const [appliesType, setAppliesType] = useState('')
  const [appliesTo, setAppliesTo] = useState([])
  const [failedCreation, setFailedCreation] = useState(false)
  const [failedCreationMessage, setFailedCreationMessage] = useState('')
  const [clientOptions, setClientOptions] = useState([])
  const [client, setClient] = useState(null)
  const [clientValue, setClientValue] = useState(null)
  const [promoType, setPromoType] = useState(null)
  const [baseBrand, setBaseBrand] = useState('')
  const [bonusBrand, setBonusBrand] = useState('')
  const [startTime, setStartTime] = useState('')
  const [endTime, setEndTime] = useState('')
  const [promoRule, setPromoRule] = useState(null)
  const [description, setDescription] = useState('')
  const [checkedMaxBonus, setCheckedMaxBonus] = useState(false)
  const [scaleArray, setScaleArray] = useState([{ min: 1, max: 0, discount: 0 }])
  const [promoScaleArray, setPromoScaleArray] = useState([
    { min: 1, max: 0, inc_factor: 0, bonus_qty: 0 }
  ])
  const [isAssorted, setIsAssorted] = useState(true)
  const [promoData, setPromoData] = useState(null)
  const [cloningPromo, setCloningPromo] = useState(false)
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false)
  const submitInProgressRef = useRef(false)
  const errorAlertRef = useRef(null)
  const [qualifiers, setQualifiers] = useState(EMPTY_QUALIFIERS)

  const [selectedQualifiers, setSelectedQualifiers] = useState(EMPTY_SELECTED_QUALIFIERS)

  const resetSelectedQualifiers = () => setSelectedQualifiers(EMPTY_SELECTED_QUALIFIERS)

  const promoTypeOptions = [
    { value: '', text: 'Escoja una opción', hidden: true },
    { value: 'bonus_product', text: 'Bonificación de una referencia' },
    { value: 'assorted_bonus_product', text: 'Bonificación surtida' },
    {
      value: 'assorted_scale_discount_product',
      text: 'Descuento de una referencia / Descuento surtido'
    }
  ]

  useEffect(() => {
    fetchQualifiers()
    setQueryParams()
  }, [])

  const BONUS_PRODUCT = 'bonus_product'
  const ASSORTED_PRODUCT = 'assorted_bonus_product'
  const DISCOUNT = 'assorted_scale_discount_product'

  const { baseProducts, clearBaseProduct } = useContext(BasePromoContext)
  const { bonusProducts, clearBonusProduct } = useContext(BonusPromoContext)
  const { scaleDiscountProducts, clearScaleDiscountProduct } = useContext(ScalePromoContext)
  const { assortedProducts, assortedBonusProductQuantity } = useContext(AssortedPromoContext)
  const { assortedBonusProducts, assortedGiftBonusProductQuantity } =
    useContext(AssortedBonusPromoContext)
  const { assortedScaleProducts, clearAssortedScaleProducts } =
    useContext(AssortedScalePromoContext)
  const [noValidPackages, setNoValidPackages] = useState(false)

  ////// Stops fetchs when page is changed
  const abortController = new AbortController()
  var abortClientController = new AbortController()
  const abortCurrentFetchs = () => {
    abortClientController.abort('Fetch Aborted by User.')
    abortController.abort('Fetch Aborted by User.')
  }
  window.addEventListener('beforeunload', abortCurrentFetchs)
  //////

  // Stops client fetch when is unfocus
  const abortClientFetchs = () => {
    abortClientController.abort('Fetch Aborted by User.')
  }
  //

  const startCloning = async (uuid) => {
    let promoToClone = await getPromoToClone(uuid)
    if (promoToClone) {
      setCloningPromo(true)
      setIsSubmitDisabled(true)
      if (
        promoToClone.promo_type != BONUS_PRODUCT &&
        promoToClone.promo_type != ASSORTED_PRODUCT &&
        promoToClone.promo_type != DISCOUNT
      ) {
        console.log('Error en duplicacion de promos (Tipo de promo): ', promoToClone.promo_type)
        setFailedCreation(true)
        setFailedCreationMessage(
          'Hubo un error al intentar obtener: el tipo de promoción, requerido para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
        )
        setTimeout(() => setFailedCreation(false), 15000)
        setIsSubmitDisabled(false)
        return setCloningPromo(false)
      } else {
        setPromoType(promoToClone.promo_type)
        if (promoToClone.promo_type == BONUS_PRODUCT) {
          setIsAssorted(false)
        } else {
          setIsAssorted(true)
        }
      }
      setDescription(promoToClone.description)
      try {
        switch (promoToClone.applies_to_type) {
          case 'qualifier':
            {
              setAppliesType('qualifier')
              const clonedQualifiers = { ...EMPTY_SELECTED_QUALIFIERS }
              PROMO_QUALIFIER_FIELDS.forEach(({ key }) => {
                if (promoToClone[key] !== null) {
                  clonedQualifiers[key] = promoToClone[key]
                }
              })
              setSelectedQualifiers(clonedQualifiers)
              setAppliesTo(buildAppliesToFromSelectedQualifiers(clonedQualifiers))
            }
            break
          case 'client':
            {
              setAppliesType('client')
              let clients = await getClient(promoToClone.qualifier_1)
              setClient(clients[0].client)
              setClientValue(clients[0])
              setAppliesTo([clients[0].client.id])
            }
            break
        }
      } catch (e) {
        console.log('Error en duplicacion de promos (Clientes o Atributos): ', e)
        setFailedCreation(true)
        setFailedCreationMessage(
          'Hubo un error al intentar obtener: Los clientes o atributos, requeridos para crear la copia de la promoción. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
        )
        setTimeout(() => setFailedCreation(false), 15000)
        setIsSubmitDisabled(false)
        return setCloningPromo(false)
      }
      setPromoData(promoToClone)
    }
  }

  const getPromoToClone = async (uuid) => {
    try {
      const response = await authFetch(`${BASE_BACKEND_URL}/promos/${uuid}`, {
        method: 'GET',
        signal: abortController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      })
        if (!response) return

      if (response.status != 200) {
        return false
      } else {
        let json = await response.json()
        return json
      }
    } catch (error) {
      if (error !== 'Fetch Aborted by User.') {
        console.error('Error:', error)
      }
    }
  }

  const fetchQualifiers = () => {
    authFetch(`${BASE_BACKEND_URL}/promo_qualifiers`, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        const qualifierData = data?.result?.[0] || EMPTY_QUALIFIERS
        setQualifiers({
          qualifier_2: qualifierData.qualifier_2 || [],
          qualifier_3: qualifierData.qualifier_3 || [],
          qualifier_4: qualifierData.qualifier_4 || [],
          qualifier_5: qualifierData.qualifier_5 || [],
          qualifier_6: qualifierData.qualifier_6 || []
        })
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const setQueryParams = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const uuidToClone = urlParams.get('clone') || ''
    if (uuidToClone) {
      startCloning(uuidToClone)
    }
  }

  const handleChange = (event) => {
    event.preventDefault()
    const obj = {}
    obj[event.target.name] = event.target.value
    // Changing the recipient preserves the promotion; changing its type resets its configuration.
    if (event.target.name === 'applies_target_to_type' || event.target.name === 'promoType') {
      if (event.target.name === 'applies_target_to_type') {
        setAppliesTo([])
        resetSelectedQualifiers()
        setClientValue(null)
        setClient(null)
        setAppliesType(obj.applies_target_to_type)
      } else {
        resetProductSelected()
        setAppliesType('')
        setAppliesTo([])
        resetSelectedQualifiers()
        setClientValue(null)
        setClient(null)
        setPromoType(obj.promoType)
        handleAssortedPromo(obj.promoType)
      }
    } else {
      setStartTime(obj.startTime)
      setEndTime(obj.endTime)
    }
  }

  const handleAssortedPromo = (promoType) => {
    if (promoType === BONUS_PRODUCT) {
      setIsAssorted(false)
    } else {
      setIsAssorted(true)
    }
  }

  const uniqueProductsById = (products) => {
    return [...new Map(products.map((item) => [item['id'], item])).values()]
  }

  const resetProductSelected = () => {
    clearBaseProduct()
    clearBonusProduct()
    clearScaleDiscountProduct()
    clearAssortedScaleProducts()
    setBaseBrand('')
    setBonusBrand('')
    setPromoRule(null)
    setCheckedMaxBonus(false)
    setPromoScaleArray([{ min: 1, max: 0, inc_factor: 0, bonus_qty: 0 }])
    setScaleArray([{ min: 1, max: 0, discount: 0 }])
  }

  const cancelCreate = (event) => {
    event.preventDefault()
    const val = window.confirm(
      '¿Esta seguro que quiere continuar? Los cambios editados no seran guardados'
    )
    if (val) {
      window.location = '/promociones'
    }
  }

  const releaseSubmit = () => {
    submitInProgressRef.current = false
    setIsSubmitDisabled(false)
  }

  const handleScaleDiscountArrayErrors = () => {
    for (let index = 0; index < scaleArray.length; index++) {
      const currentScale = scaleArray[index]
      if (currentScale.min === 0) {
        setFailedCreationMessage(
          'Minimo de venta en escala ' + (index + 1) + ' tiene que ser mayor a 0.'
        )
        return true
      } else if (currentScale.max === 0) {
        setFailedCreationMessage(
          'Maximo de venta en escala ' + (index + 1) + ' tiene que ser mayor a 0.'
        )
        return true
      } else if (currentScale.discount === 0) {
        setFailedCreationMessage(
          'Campo de porcentaje de descuento en escala ' + (index + 1) + ' debe ser entre 1 y 100.'
        )
        return true
      } else if (currentScale.min >= currentScale.max) {
        setFailedCreationMessage('La escala ' + (index + 1) + ' debe ser consecutiva.')
        return true
      }
    }
    return false
  }

  const handleScaleBonusArrayErrors = () => {
    for (let index = 0; index < promoScaleArray.length; index++) {
      const currentScale = promoScaleArray[index]
      if (currentScale.min === 0) {
        setFailedCreationMessage(
          'Minimo de venta en escala ' + (index + 1) + ' tiene que ser mayor a 0.'
        )
        return true
      } else if (currentScale.max === 0) {
        setFailedCreationMessage(
          'Maximo de venta en escala ' + (index + 1) + ' tiene que ser mayor a 0.'
        )
        return true
      } else if (currentScale.inc_factor === 0) {
        setFailedCreationMessage(
          'Factor de incremento en escala ' + (index + 1) + ' tiene que ser mayor a 0.'
        )
        return true
      } else if (currentScale.bonus_qty === 0) {
        setFailedCreationMessage(
          'Campo de cantidad bonificada en escala ' + (index + 1) + ' tiene que ser mayor a 0.'
        )
        return true
      } else if (currentScale.min >= currentScale.max) {
        setFailedCreationMessage('La escala ' + (index + 1) + ' debe ser consecutiva.')
        return true
      }
    }
    return false
  }

  const isEmpty = (str) => !str || str.length === 0

  const base_Products_Details = (products) =>
    products.slice(0, 5).map((product) => ({
      db_ref: product.db_ref,
      name: product.base_product_name,
      id: Array.isArray(product.base_product_ids)
        ? product.base_product_ids[0]
        : product.base_product_ids
    }))

  const sendCreateParams = (event) => {
    event.preventDefault()

    if (submitInProgressRef.current || isSubmitDisabled) {
      return
    }
    submitInProgressRef.current = true
    setIsSubmitDisabled(true)

    let limit_bonus_quantity = 0
    let bonus_product_quantity = 0
    let baseAssortedProducts = []
    let bonusAssortedProducts = []

    baseAssortedProducts = uniqueProductsById(assortedProducts)
    bonusAssortedProducts = uniqueProductsById(assortedBonusProducts)
    const bonus_quantity_zero = bonusProducts.filter((obj) => obj.bonus_quantity <= 0)
    const base_quantity_zero = baseProducts.filter((obj) => obj.base_quantity <= 0)
    const appliesToMessageError =
      'Error al intentar guardar la promoción: debes escoger al menos un cliente o, como mínimo escoger 1 atributo.'
    if (appliesTo.length === 0) {
      releaseSubmit()
      setFailedCreation(true)
      setFailedCreationMessage(appliesToMessageError)
      return setTimeout(() => setFailedCreation(false), 15000)
    } else if (
      appliesType === PROMO_QUALIFIER_TYPE &&
      !hasAnySelectedQualifier(selectedQualifiers)
    ) {
      releaseSubmit()
      setFailedCreation(true)
      setFailedCreationMessage(appliesToMessageError)
      return setTimeout(() => setFailedCreation(false), 15000)
    }
    if (promoType === BONUS_PRODUCT) {
      limit_bonus_quantity = Number(bonusProducts[0]?.bonus_limit)
      bonus_product_quantity = Number(bonusProducts[0]?.bonus_quantity)
    }

    if (promoType === ASSORTED_PRODUCT) {
      limit_bonus_quantity = Number(assortedBonusProducts[0]?.bonus_limit)
      bonus_product_quantity = assortedGiftBonusProductQuantity
    }
    if (promoType === DISCOUNT && handleScaleDiscountArrayErrors()) {
      releaseSubmit()
      setFailedCreation(true)
      return setTimeout(() => setFailedCreation(false), 15000)
    } else if (
      (promoType === BONUS_PRODUCT || promoType === ASSORTED_PRODUCT) &&
      promoRule === 'scale' &&
      handleScaleBonusArrayErrors()
    ) {
      releaseSubmit()
      setFailedCreation(true)
      return setTimeout(() => setFailedCreation(false), 15000)
    } else if (
      promoType === BONUS_PRODUCT &&
      promoRule === 'one_increment' &&
      (bonus_quantity_zero.length > 0 || base_quantity_zero.length > 0)
    ) {
      releaseSubmit()
      setFailedCreation(true)
      setFailedCreationMessage(
        'Hay un error en el formulario, verifique la información, Existen bonificaciones con cantidades en 0.'
      )
      return setTimeout(() => setFailedCreation(false), 15000)
    } else if (
      (promoType === BONUS_PRODUCT || promoType === ASSORTED_PRODUCT) &&
      checkedMaxBonus === true &&
      limit_bonus_quantity < bonus_product_quantity
    ) {
      releaseSubmit()
      setFailedCreation(true)
      setFailedCreationMessage(
        'La cantidad introducida es menor a la necesaria para activar la bonificación.'
      )
      return setTimeout(() => setFailedCreation(false), 15000)
    } else if (noValidPackages) {
      return showCreationError('Los productos seleccionados no tienen empaques válidos. Revisa los productos y sus unidades de venta antes de guardar.')
    } else {
      const selectedProducts =
        baseProducts.length > 0
          ? uniqueProductsById(baseProducts)
          : uniqueProductsById(assortedProducts)
      const brandDetails = baseBrand
        ? {
          db_ref: baseBrand.db_ref,
          id: baseBrand.id,
          name: baseBrand.name
        }
        : null
      const productDetails =
        selectedProducts.length > 0 ? base_Products_Details(selectedProducts) : null
      const promoDetails = []
      if (brandDetails) {
        promoDetails.push(brandDetails)
      } else if (productDetails) {
        promoDetails.push(...productDetails)
      }
      const body = {
        start_time: startTime,
        end_time: endTime,
        promo_details: promoDetails,
        applies_to_type: appliesType,
        applies_to:
          appliesType === PROMO_CLIENT_TYPE
            ? appliesTo
            : PROMO_QUALIFIER_FIELDS.map(({ key }) =>
                (selectedQualifiers[key] || []).length > 0 ? key : null
              ),
        qualifier_1: appliesType === PROMO_CLIENT_TYPE ? client.db_ref : null,
        ...Object.fromEntries(
          PROMO_QUALIFIER_FIELDS.map(({ key }) => [
            key,
            (selectedQualifiers[key] || []).length > 0 ? selectedQualifiers[key] : null
          ])
        ),
        description: isEmpty(description) ? '-' : description
      }
      if (promoType === BONUS_PRODUCT) {
        body['products'] = [
          {
            basePackageQuantity: baseProducts[0].basePackageQuantity,
            base_package: baseProducts[0].base_package,
            base_product_ids: baseProducts[0].base_product_ids,
            base_quantity: baseProducts[0].base_quantity,
            bonus_package: bonusProducts[0].bonus_package,
            bonus_product_ids: bonusProducts[0].bonus_product_ids,
            bonus_quantity: bonusProducts[0].bonus_quantity,
            bonus_limit: bonusProducts[0].bonus_limit,

            base_product_uid: baseProducts[0].base_product_uid,
            base_product_db_ref: baseProducts[0].base_product_db_ref,
            base_product_name: baseProducts[0].base_product_name,
            base_package_uid: baseProducts[0].base_package_uid,

            bonus_product_uid: bonusProducts[0].bonus_product_uid,
            bonus_product_db_ref: bonusProducts[0].bonus_product_db_ref,
            bonus_product_name: bonusProducts[0].bonus_product_name,
            bonus_package_uid: bonusProducts[0].bonus_package_uid,
            db_ref: baseProducts[0].db_ref,
            name: baseProducts[0].name,
            id: baseProducts[0].id,
            tax: baseProducts[0].tax,

            promo_rule_type: promoRule,
            promo_scale_array: promoScaleArray
          }
        ]
        postCreateBonusProductPromo(body)
      }

      if (promoType === ASSORTED_PRODUCT) {
        body['products'] = [
          {
            bonus_product_uid: assortedBonusProducts[0].bonus_product_uid,
            bonus_package_uid: assortedBonusProducts[0].bonus_package_uid,
            bonus_package: assortedBonusProducts[0].bonus_package,
            bonus_product_name: assortedBonusProducts[0].bonus_product_name,
            bonus_product_db_ref: assortedBonusProducts[0].bonus_product_db_ref,
            bonus_package_units: bonusAssortedProducts.map(bp => bp.bonus_package),
            bonus_product_ids: bonusAssortedProducts.map(bp => bp.id),
            bonus_product_uids: bonusAssortedProducts.map(bp => bp.bonus_product_uid),
            bonus_package_uids: Object.values(assortedBonusProducts[0].bonus_package_hash),
            bonus_package_hash: JSON.stringify(assortedBonusProducts[0].bonus_package_hash),
            bonus_limit: limit_bonus_quantity,
            bonus_quantity: bonus_product_quantity,

            base_quantity: assortedBonusProductQuantity,
            base_package_units: baseAssortedProducts.map(pr => pr.base_package),
            base_product_ids: baseAssortedProducts.map(pr => pr.id),
            base_product_uids: baseAssortedProducts.map(pr => pr.base_product_uid),
            base_package_uids: baseAssortedProducts.map(pr => pr.base_package_uid),
            base_package_hash: JSON.stringify(assortedProducts[0].base_package_hash),
            base_brand: baseBrand?.db_ref,
            bonus_brand: bonusBrand?.db_ref,
            promo_rule_type: promoRule,
            promo_scale_array: promoScaleArray
          }
        ]

        postCreateAssortedBonusProductPromo(body)
      }

      if (promoType === DISCOUNT) {
        body['products'] = [
          {
            base_package_units: baseAssortedProducts.map((pr) => pr.base_package),
            base_product_ids: baseAssortedProducts.map((pr) => pr.id),
            base_product_uids: baseAssortedProducts.map((pr) => pr.base_product_uid),
            base_package_uids: baseAssortedProducts.map((pr) => pr.base_package_uid),
            base_package_hash: JSON.stringify(baseAssortedProducts[0].base_package_hash),
            scale_discount_hash: scaleArray,
            base_brand: baseBrand?.db_ref
          }
        ]
        postCreateAssortedScaleDiscountPromo(body)
      }

      if (![BONUS_PRODUCT, ASSORTED_PRODUCT, DISCOUNT].includes(promoType)) {
        releaseSubmit()
      }
    }
  }

  const showCreationError = (message) => {
    releaseSubmit()
    setFailedCreationMessage(message)
    setFailedCreation(true)
    errorAlertRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'center' })
  }

  useEffect(() => {
    if (failedCreation) {
      errorAlertRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'center' })
    }
  }, [failedCreation])

  const handleInvalidField = (event) => {
    const field = event.target
    const fieldNames = {
      promoType: 'Tipo de promoción',
      applies_target_to_type: 'Clientes o atributos',
      applies_base_product_selection_type: 'Base de la promoción',
      applies_bonus_product_selection_type: 'Producto de bonificación',
      base_package_promo: 'Unidad de venta base',
      bonus_package_promo: 'Unidad de venta de bonificación',
      'min-quantity': 'Mínimo de venta',
      'max-quantity': 'Máximo de venta',
      'percentage-quantity': 'Porcentaje de descuento',
      startTime: 'Fecha inicio',
      endTime: 'Fecha final',
      description: 'Descripción'
    }
    showCreationError(`${fieldNames[field.name] || 'Campo requerido'}: ${field.validationMessage}`)
  }

  const postCreateBonusProductPromo = (body) => {
    authFetch(`${BASE_BACKEND_URL}/bonus_product_promos`, {
      method: 'POST',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
      .then((r) => evaluateResponse(r))
      .catch((error) => {
        releaseSubmit()
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
          showCreationError('No se pudo guardar la promoción. Revisa tu conexión e inténtalo nuevamente.')
        }
      })
  }

  const postCreateAssortedBonusProductPromo = (body) => {
    authFetch(`${BASE_BACKEND_URL}/assorted_bonus_product_promos`, {
      method: 'POST',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
      .then((r) => evaluateResponse(r))
      .catch((error) => {
        releaseSubmit()
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
          showCreationError('No se pudo guardar la promoción. Revisa tu conexión e inténtalo nuevamente.')
        }
      })
  }

  const postCreateAssortedScaleDiscountPromo = (body) => {
    authFetch(`${BASE_BACKEND_URL}/assorted_scale_discount_product_promos`, {
      method: 'POST',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
      .then((r) => evaluateResponse(r))
      .catch((error) => {
        releaseSubmit()
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
          showCreationError('No se pudo guardar la promoción. Revisa tu conexión e inténtalo nuevamente.')
        }
      })
  }

  const evaluateResponse = async (response) => {
    // evaluate responses for status 422 or 500
    if (response?.status === 422) {
      releaseSubmit()
      setFailedCreation(true)
      let obj = await response.json()
      const errors = obj?.data || obj?.errors
      setFailedCreationMessage(
        errors
          ? Object.values(errors).flat().join('. ')
          : obj?.message || 'Hay un error en el formulario, verifique la información.'
      )
      return setTimeout(() => setFailedCreation(false), 15000)
    } else if (response?.status === 500) {
      releaseSubmit()
      setFailedCreation(true)
      setFailedCreationMessage(
        'Error al crear nueva promoción: existe otra promoción creada con los mismos valores. Por favor, editar esta promoción.'
      )
      return setTimeout(() => setFailedCreation(false), 15000)
    } else if (response?.status === 404) {
      releaseSubmit()
      setFailedCreation(true)
      setFailedCreationMessage('Hay un error en el formulario, verifique la información.')
      return setTimeout(() => setFailedCreation(false), 15000)
    } else if (response?.ok) {
      window.location = `/promociones/?successCreateForNewPromo=true`
    } else {
      releaseSubmit()
      console.log('error: ', response)
      setFailedCreation(true)
      setFailedCreationMessage('No se pudo guardar la promoción. Inténtalo nuevamente.')
      return setTimeout(() => setFailedCreation(false), 15000)
    }
  }

  const hasQualifierOptions = PROMO_QUALIFIER_FIELDS.some(
    ({ key }) => (qualifiers?.[key] || []).length > 0
  )

  useEffect(() => {
    if (!hasQualifierOptions && appliesType === 'qualifier') {
      setAppliesType('')
      setAppliesTo([])
      resetSelectedQualifiers()
    }
  }, [appliesType, hasQualifierOptions])

  const handleClientOption = (event) => {
    if (event != null) {
      setClientValue(event)
      setClient(event.client)
      setAppliesTo([event.client.id])
    } else {
      setClientValue(null)
      setClient(null)
      setAppliesTo([])
    }
  }
  const handleChangeQualifier = (qualifierKey, event) => {
    const nextSelected = {
      ...selectedQualifiers,
      [qualifierKey]: event != null ? event.map((e) => e.value) : []
    }
    setSelectedQualifiers(nextSelected)
    setAppliesTo(buildAppliesToFromSelectedQualifiers(nextSelected))
  }

  const sleep = (ms) =>
    // eslint-disable-next-line no-undef
    new Promise((resolve) => {
      setTimeout(() => {
        resolve()
      }, ms)
    })

  const getClient = async (inputValue) => {
    if (inputValue.length >= 3) {
      abortClientController = new AbortController()
      return authFetch(`${BASE_BACKEND_URL}/clients?q=${inputValue}&active=true`, {
        method: 'GET',
        signal: abortClientController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
        if (!response) return
        return response.json()
      })
        .then((data) =>
          data.table.map((cl) => ({
            value: cl.name,
            label: `${cl.name} - ${cl.db_ref}`,
            client: cl
          }))
        )
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error fetching clients:', error)
            return []
          }
        })
    }
  }

  return (
    <>
      {failedCreation === true && (
        <div ref={errorAlertRef} className="alert alert-danger" role="alert">
          <strong className="ml-65">{failedCreationMessage}</strong>
        </div>
      )}
      <div>
        <div className="show-title">
          <h2 style={{ fontWeight: 600, fontSize: 28 }}>Promoción nueva</h2>
        </div>
        <form onSubmit={sendCreateParams} onInvalidCapture={handleInvalidField}>
          <StickyActionBar
            title="Ingrese los siguientes datos para crear una promoción nueva"
            onCancel={cancelCreate}
            primaryLabel="Crear promoción"
            primaryIcon={FloppyDisk}
            primaryButtonType="submit"
            isSaving={isSubmitDisabled}
            savingLabel={cloningPromo ? 'Cargando...' : 'Guardando...'}
          />
          <div className="index-table">
            <div className="show-area">
              <div className="create-promo-wrapper">
                {cloningPromo && (
                  <div className="promo-form-section">
                    <div className="title-promos-form">
                      <b>Cargando promoción...</b>
                    </div>
                  </div>
                )}
                {!cloningPromo && (
                  <div className="promo-card">
                    <div className="title-promos-form">
                      <b>1. Tipo de promoción</b>
                    </div>
                    <hr className="hr-promo-card" />
                    <p className="promo-card-subtitle">1.1: Escoja el tipo de promoción</p>
                    <select
                      onChange={handleChange}
                      value={promoType || ''}
                      className="select-promo-type form-control custom-select"
                      name="promoType"
                      required
                    >
                      {promoTypeOptions.map((option) => (
                        <option key={option.value + 1} value={option.value} hidden={option.hidden}>
                          {option.text}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {promoType !== null && !cloningPromo && (
                  <div className="promo-card">
                    <div className="title-promos-form">
                      <b>2. Clientes o atributo(s)</b>
                    </div>
                    <hr className="hr-promo-card" />
                    <p className="promo-card-subtitle">
                      2.1: Escoja cómo se debe de aplicar la promoción, si es por cliente individual
                      o por atributo(s)
                    </p>
                    <div>
                      <select
                        onChange={handleChange}
                        className="select-promo-type form-control custom-select"
                        name="applies_target_to_type"
                        value={appliesType}
                        required
                      >
                        <option value="" hidden>
                          Escoger una opcion
                        </option>
                        <option value="client">Cliente individual</option>
                        {hasQualifierOptions && <option value="qualifier">Atributo(s)</option>}
                      </select>
                    </div>

                    {appliesType === 'client' && (
                      <>
                        <p className="promo-card-subtitle mt-33">
                          2.2: Escoja al cliente que debe de aplicar la promoción
                        </p>
                        <div className="promo-card-heading">Cliente</div>
                        <AsyncSelect
                          placeholder={'Buscar cliente por nombre o código'}
                          noOptionsMessage={() => 'Buscar Clientes'}
                          loadingMessage={() => 'Cargando clientes...'}
                          name="selectOptionClients"
                          loadOptions={getClient}
                          className="clients"
                          isClearable={true}
                          searchParamName={'q'}
                          isSearchable={!client}
                          value={clientValue}
                          onChange={(e) => handleClientOption(e)}
                          onBlur={abortClientFetchs}
                        />
                      </>
                    )}
                    {appliesType === 'qualifier' && hasQualifierOptions && (
                      <>
                        <p className="promo-card-subtitle mt-33">
                          2.2: Escoja los atributos que deben de tener los clientes para activar la
                          promoción. Mínimo debe escoger 1 atributo.
                        </p>
                        {PROMO_QUALIFIER_FIELDS.map(({ key, label }, index) => {
                          const options = (qualifiers?.[key] || []).map((value) => ({
                            value,
                            label: value,
                            [key]: value
                          }))
                          const selected = selectedQualifiers[key] || []
                          const isLast = index === PROMO_QUALIFIER_FIELDS.length - 1

                          return (
                            <React.Fragment key={key}>
                              <div className="promo-card-heading">{label}</div>
                              <Select
                                placeholder={'Buscar o escoger una opcion'}
                                noOptionsMessage={() => 'Buscar'}
                                loadingMessage={() => 'Cargando...'}
                                className={`qualifier ${isLast ? '' : 'mb-30'}`}
                                isDisabled={options.length === 0}
                                isClearable={true}
                                isMulti
                                value={selected.map((q) => ({ value: q, label: q }))}
                                onChange={(e) => handleChangeQualifier(key, e)}
                                options={options}
                              />
                            </React.Fragment>
                          )
                        })}
                      </>
                    )}
                  </div>
                )}

                {promoType !== null && (
                  <>
                    <ProductSection
                      promoData={promoData}
                      cloningPromo={cloningPromo}
                      setCloningPromo={setCloningPromo}
                      setIsSubmitDisabled={setIsSubmitDisabled}
                      appliesTo={appliesTo}
                      promoType={promoType}
                      isAssorted={isAssorted}
                      baseBrand={baseBrand}
                      setBaseBrand={setBaseBrand}
                      bonusBrand={bonusBrand}
                      setBonusBrand={setBonusBrand}
                      setPromoRule={setPromoRule}
                      setPromoScaleArray={setPromoScaleArray}
                      setCheckedMaxBonus={setCheckedMaxBonus}
                      setScaleArray={setScaleArray}
                      failedCreation={failedCreation}
                      setFailedCreation={setFailedCreation}
                      setFailedCreationMessage={setFailedCreationMessage}
                      setNoValidPackages={setNoValidPackages}
                    />

                    {(promoType === BONUS_PRODUCT || promoType === ASSORTED_PRODUCT) && (
                      <BonusPromoRuleSection
                        cloningPromo={cloningPromo}
                        promoType={promoType}
                        isAssorted={isAssorted}
                        promoRule={promoRule}
                        setPromoRule={setPromoRule}
                        promoScaleArray={promoScaleArray}
                        setPromoScaleArray={setPromoScaleArray}
                        checkedMaxBonus={checkedMaxBonus}
                        setCheckedMaxBonus={setCheckedMaxBonus}
                      />
                    )}
                    {promoType === DISCOUNT && (
                      <DiscountPromoRuleSection
                        cloningPromo={cloningPromo}
                        scaleArray={scaleArray}
                        setScaleArray={setScaleArray}
                      />
                    )}

                    <DateAndDescriptionSection
                      cloningPromo={cloningPromo}
                      promoType={promoType}
                      promoScaleArray={promoScaleArray}
                      scaleArray={scaleArray}
                      startTime={startTime}
                      setStartTime={setStartTime}
                      endTime={endTime}
                      setEndTime={setEndTime}
                      description={description}
                      setDescription={setDescription}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default CreatePromo
